import * as React from "react";

const TextInput = (props) => {
  return <input type="tel" {...props} />;
};

export default TextInput;
